import React from 'react';
import { ClassValue } from 'classnames/types';
import styles from './Title.module.scss';
import Typography, { SupportedTagName, TypographyProps } from '../Typography';
import { ArrayElementType } from '../../../types/utils/ArrayElementType';

type TitleProps<T extends SupportedTagName> = {
  /** Modifier for the font size. Font sizes are responsive */
  size?: SupportedTitleSize;
} & Omit<TypographyProps<T>, 'font' | 'fontWeight'>;
// Alias for backwards compatibility
export type TitleAttributes = TitleProps<SupportedTagName>;

function Title<T extends SupportedTagName>({
  tagName,
  size = 'lg',
  className,
  children,
  ...props
}: TitleProps<T>) {
  const classNames: ClassValue = [
    styles[`title__size_${size.toLowerCase()}`],
    className,
  ];

  return (
    <Typography
      {...props}
      tagName={tagName as SupportedTagName} // this circumvents some weird ts problem
      className={classNames}
      font="teliasans"
      fontWeight="bold"
    >
      {children}
    </Typography>
  );
}

export const supportedTitleSizes = ['lg', 'md', 'sm', 'xs', 'xxs'] as const;

export type SupportedTitleSize = ArrayElementType<typeof supportedTitleSizes>;

export default Title;
